import React, { useState } from "react";
import useStyles from 'isomorphic-style-loader/useStyles'
import classes from './style.module.scss'
import { FormattedMessage } from "react-intl";
import { getProductUrl } from "../../../../../../../../utils/product";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { getColor } from "../../../../../../../../utils/product";
import { useDispatch } from "react-redux";
import { action_fetch_promotions } from "../../../../../../../../store/actions/pages/product";

const ProductColorInformation = props =>{
    useStyles(classes);
    const dispatch = useDispatch()

    const { productHooks, imagePrefix, changeHoverImage } = props;
    const { selectedProduct, productVO, selectProduct, isBeautyMakeup } = productHooks; 
    const [hoverColor,setHoverColor] = useState(null);

    const colorMouseEvent = (product,isHover) =>{
        const selectedColor = product?.theme || product?.variants?.[0]?.color
        if(isHover){
            setHoverColor(selectedColor);
            changeHoverImage(product?.variants?.[0]?.image);
        }else{
            setHoverColor(null);
            changeHoverImage(null)
        }
    }

    const isSameProduct = (p1, p2) => {
        return p1?.id === p2?.id && p1?.variants?.[0]?.color === p2?.variants?.[0]?.color;
    }

    return <React.Fragment>
        {
            productVO?.products?.length > 1 && <div className={classes.ProductColorInformation}>
                <div className={classes.Title}>
                    <span><FormattedMessage id="color" defaultMessage="Color" />:</span>
                    <span>{hoverColor || (selectedProduct?.theme || selectedProduct?.variants[0]?.color)}</span>
                </div>
                <div className={classes.Content}>
                    <ul className={classes.ColorUl}>
                        {
                            productVO?.products?.map((product,index) =>{
                                return isBeautyMakeup ? (
                                    <li key={product.id+index}>
                                        <a
                                            className={`${classes.GeneralColor} ${classes.BeautyColor} ${isSameProduct(product,selectedProduct)?classes.Active:""}`}
                                            href={getProductUrl(product?.id, product?.name)}
                                            onClick={(evt)=>{
                                                evt.preventDefault()
                                                // dispatch(action_fetch_promotions(product?.id))
                                                selectProduct(product?.id, product?.variants?.[0]?.color) 
                                            }}
                                        >
                                            <span
                                                className={classes.RegularColor}
                                                style={{
                                                    textDecoration: 'none',
                                                    backgroundColor: `${getColor(product?.variants?.[0]?.color)}`,
                                                    backgroundImage: product?.variants?.[0]?.colorImage ? `url(${product?.variants?.[0]?.colorImage})` : undefined
                                                }}
                                            ></span>

                                            {
                                                product?.hotColor && <span className={classes.HotColor}>
                                                    <span>Hot</span>
                                                </span>
                                            }
                                        </a>
                                    </li>
                                ) : (
                                    <li 
                                        key={product.id+index}
                                        onMouseEnter={()=>colorMouseEvent(product,true)}
                                        onMouseLeave={()=>colorMouseEvent(product,false)}
                                    >
                                        <a 
                                            className={`${classes.GeneralColor} ${classes.NormalColor} ${isSameProduct(product,selectedProduct)?classes.Active:""}`}
                                            href={getProductUrl(product?.id, product?.name)}
                                            onClick={(evt)=>{
                                                evt.preventDefault()
                                                // dispatch(action_fetch_promotions(product?.id))
                                                selectProduct(product?.id, product?.variants?.[0]?.color) 
                                            }}
                                        >
                                            <span
                                                className={classes.RegularColor}
                                                style={{
                                                    textDecoration: 'none',
                                                    backgroundColor: `${getColor(product?.variants?.[0]?.color)}`,
                                                    backgroundImage: `url(${imagePrefix}/small/${product?.variants?.[0]?.image})`
                                                }}
                                            ></span>

                                            {
                                                product?.hotColor && <span className={classes.HotColor}>
                                                    <span>Hot</span>
                                                </span>
                                            }
                                        </a>
                                    </li>
                                )
                                
                            })
                        }
                    </ul>
                </div>
        </div>  
        }
    </React.Fragment> 
}

export default ProductColorInformation;